import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b0e5d134&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b0e5d134&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e5d134",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0e5d134')) {
      api.createRecord('b0e5d134', component.options)
    } else {
      api.reload('b0e5d134', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b0e5d134&scoped=true", function () {
      api.rerender('b0e5d134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/salesPromotion/list/index.vue"
export default component.exports